// https://sg31b0.familysearch.org/service/ident/cis/cis-public-api/resource_IdentityWebService.html#resource_IdentityWebService_updateUser_POST
// https://sg31b0.familysearch.org/service/ident/cis/cis-public-api/json_Identity.html
// https://sg31b0.familysearch.org/service/ident/cis/cis-public-api/json_ParentalConsent.html
import axios from '@fs/zion-axios'
import { clearCachedUser, getUser } from '@fs/zion-user'
import cisAxiosConfig from '../cisAxiosConfig'
import withNoticeWarnings from './withNoticeWarnings'
import throwCisError from './throwCisError'
import { VerificationCodeInvalidError } from '../errors'

export async function verifySmsCode(token) {
  try {
    await axios.get(`/identity/register-api/verify/sms/${token}`)
  } catch (err) {
    if (err?.response?.status === 404) {
      throw new VerificationCodeInvalidError()
    } else {
      throw err
    }
  }
}

export const resendSmsVerification = (username) => () =>
  axios.post(`/identity/register-api/resend/sms`, null, { params: { username, parentalConsent: 'parentalConsent' } })

export async function updateUserWithParentalConsent({
  consentType: type,
  consentValue: value, // (e.g. parentSmsNumber )
  parentSmsCountry,
  childBirthDate,
  childRecordNumber,
}) {
  const parentalConsent = {
    type,
    value,
    // handle empty string here just in case
    country: parentSmsCountry || undefined,
  }
  const { cisId: id } = await getUser()
  try {
    await withNoticeWarnings(
      axios.post(
        '/service/ident/cis/cis-public-api/v4/user',
        {
          users: [
            {
              parentalConsent,
              id,
              type: 'userAccount',
              birthDate: childBirthDate,
              membershipNumber: childRecordNumber,
            },
          ],
        },
        {
          ...cisAxiosConfig,
        }
      )
    )
    // Don't bother with any profile cache busting because we will be logging the user out.
    // However, clear zion user cache
    clearCachedUser()
  } catch (error) {
    throwCisError(error)
  }
}

export default updateUserWithParentalConsent
